import * as React from "react";
const SvgGitBranch01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.965 18a1.965 1.965 0 1 0-3.93 0 1.965 1.965 0 0 0 3.93 0m0-10a1.965 1.965 0 1 0-3.93 0 1.965 1.965 0 0 0 3.93 0m2.07 0A4.035 4.035 0 0 1 14.1 9.035H4.035V13.2c0 .857 0 1.438.037 1.886.036.436.1.656.177.807.188.37.489.67.858.858.151.077.37.141.807.177.448.036 1.029.037 1.886.037h6.3a4.036 4.036 0 1 1 0 2.07H7.8c-.823 0-1.503 0-2.055-.045-.564-.046-1.086-.145-1.577-.395a4.03 4.03 0 0 1-1.763-1.763c-.25-.491-.35-1.013-.395-1.577-.045-.552-.045-1.232-.045-2.055V3a1.035 1.035 0 0 1 2.07 0v3.965H14.1A4.036 4.036 0 0 1 22.035 8"
}));
export default SvgGitBranch01;
//# sourceMappingURL=GitBranch01.js.map